$(document).ready(function () {
  $(".collecton-slider").slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $(".collection-prev"),
    nextArrow: $(".collection-next"),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".btn-buy-now").forEach(function (button) {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");

      // Add the product to the cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then(() => {
          // Redirect to the checkout page
          window.location.href = "/checkout";
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  });
});
